// Configuração da API usando URL relativa
export const API_CONFIG = {
  baseURL: '/api',
  timeout: 900000  // 15 minutos para Claude API
};